var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 46,
    viewBox: "0 0 28 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7273 39.0179L13.1515 25.875C11.4545 24.2321 11.4545 21.7679 13.1515 20.125L26.7273 6.98214C28.4242 5.33929 28.4242 2.875 26.7273 1.23214C25.0303 -0.410713 22.4848 -0.410713 20.7879 1.23214L1.27273 20.125C-0.424242 21.7679 -0.424242 24.2321 1.27273 25.875L20.7879 44.7679C22.4848 46.4107 25.0303 46.4107 26.7273 44.7679C28.4242 43.125 28.4242 40.6607 26.7273 39.0179Z",
    fill: "#4A4C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.bc137141ba95e727fcec14b66901beeb.svg";
export { ForwardRef as ReactComponent };